import IndustriesSubindustries from './IndustriesSubindustries';

export default IndustriesSubindustries;
